import { NavLink, Outlet } from "react-router-dom";

export function AdminLayout() {
  return (
    <main className="page">
      <section className="admin-shell">
        <header className="admin-shell__header">
          <h1>Admin Console</h1>
          <p className="muted">
            Monitor system health, manage user access, and keep card data current.
          </p>
        </header>

        <div className="admin-side">
          <aside className="admin-sidebar">
            <nav className="admin-nav" aria-label="Console sections">
              <NavLink to="/admin" end>Overview</NavLink>
              <NavLink to="/admin/llm">LLM connection</NavLink>
              <NavLink to="/admin/users">Users</NavLink>
              <NavLink to="/admin/update">Card data update</NavLink>
            </nav>
          </aside>

          <div className="admin-content admin-main-card">
            <Outlet />
          </div>
        </div>
      </section>
    </main>
  );
}
